import React from 'react';

import Editor from '@monaco-editor/react';

interface EditorProps {
	codeText: string;
	theme: string;
	editorLang: string;
	handleChange: any;
	fontSize: number;
}

const MonacoEditor: React.FC<EditorProps> = ({
	codeText,
	handleChange,
	theme,
	editorLang,
	fontSize,
}) => {
	return (
		<div className={'code-editor'}>
			<Editor
				className={'main-editor'}
				height="100vh"
				defaultLanguage={'java'}
				language={editorLang}
				value={codeText}
				onChange={handleChange}
				theme={theme}
				options={{ fontSize: fontSize }}
			/>
		</div>
	);
};

export default MonacoEditor;
